import idb from '~/app/idb'
import appStore from '~/app/store'
import config from '@/app/config'
import utils from '@/app/utils'

export default {
  WEIGHT: 'weight',
  STATURE: 'stature',
  BMI: 'bmi',
  getLabel (type, withUnits = false) {
    let label
    switch (type) {
      case this.WEIGHT:
        label = 'Вес'
        if (withUnits) {
          label += ' (кг)'
        }
        break
      case this.STATURE:
        label = 'Рост'
        if (withUnits) {
          label += ' (см)'
        }
        break
      case this.BMI:
        label = 'Индекс массы'
        break
    }
    return label
  },
  calcBMI (weight, stature) {
    return parseInt(weight / (stature * stature) * 10000 * 100) / 100
  },
  getColor (type) {
    return config.graphs[type].color || '#000000'
  },
  getItems () {
    return idb.get(idb.MEASURES, (store) => {
      const profileId = appStore.state.profile.id || 0
      if (profileId) {
        let profileIndex = store.index(idb.INDEX_MEASURE_PROFILE)
        return profileIndex.getAll(IDBKeyRange.only(profileId))
      }
      return []
    })
  },
  getMeasureByDate (profileId, dt) {
    return idb.get(idb.MEASURES, (store) => {
      let profileIndex = store.index(idb.INDEX_MEASURE_PROFILE_DT)
      return profileIndex.get(IDBKeyRange.only([profileId, dt]))
    })
  },
  getAgeInYears (profile, measure) {
    const tm = new Date(measure.dt) - new Date(profile.birthdate)
    return parseInt(Math.max(0, tm) * 100 / (1000 * 3600 * 24 * 365)) / 100
  },
  getAgeInHuman (profile, measure) {
    const yearsFloat = this.getAgeInYears(profile, measure)
    if (yearsFloat) {
      const years = parseInt(yearsFloat)
      const months = Math.min(11, parseInt((yearsFloat - years + 0.04) * 12))
      // console.log({ dt: measure.dt, birthdate: profile.birthdate, yearsFloat, years, months })
      return years +
        ' ' +
        utils.pluralForm(years, 'г. ', 'г. ', 'л. ') +
        ' ' +
        months +
        ' мес.'
    }
    return ''
  },
  save (obj = {
    dt: '',
    stature: '',
    weight: ''
  }) {
    obj.profileId = appStore.state.profile.id
    if (!obj.profileId) {
      throw new Error('Profile not active')
    }
    if (!obj.dt) {
      throw new Error('Measure date is empty')
    }
    // Try to find measure with same date
    return this.getMeasureByDate(obj.profileId, obj.dt).then(measure => {
      if (measure) {
        obj.id = measure.id
      }
      return idb.save(idb.MEASURES, obj, !obj.id)
    })
  },
  remove (id) {
    return idb.remove(idb.MEASURES, id)
  }
}
